import { useCallback, useEffect, type FunctionComponent } from "react";
import { Outlet, useParams, useSearchParams } from "react-router-dom";
import { useToast } from "../../../hooks/use-toast";
import usePostStore from "../../store/post.store";
import { debounce, handleHttpError } from "../../../utils/utils";
import Spinner from "../../../components/spinner.components";
import { CampaignPost } from "../../components/core/campaign-post.core";
import type { IPost } from "../../../types/models/post.models.types";
import { useSearchPostsHttp } from "../../hooks/http/posts/search-posts.hook";


const CampaignPostSearchPartial: FunctionComponent = () => {
  const [search] = useSearchParams();
  const { campaignId } = useParams();
  const { execute: searchPostsHttp, fetching: searching } =
    useSearchPostsHttp();

  const { toast } = useToast();
  const { setData, data: postStore } = usePostStore();

  const debouncedPostSearch = useCallback(
    debounce(async (searchValue: string) => {
      if (searchValue.trim().length < 4) return;
      if (!campaignId) return;

      const response = await searchPostsHttp({
        body: null,
        queryParams: {
          campaignId: campaignId,
          query: searchValue,
        },
      });
      if (!response.success) {
        return handleHttpError(response, toast);
      }
      setData(response.data.posts);
    }, 500),
    []
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (search.get("query")) {
      setData([]);
      debouncedPostSearch(search.get("query") ?? "");
    }
  }, [search.get("query")]);

  console.log(search.get("query"));
  return (
    <div className="flex flex-col px-10 w-full">
      <div className="py-5 w-full font-semibold text-3xl">Search results:</div>
      {searching ? (
        <div className="flex justify-center items-center h-96">
          <Spinner width={20}/>
        </div>
      ) : (
        <div className="gap-6 grid grid-cols-3">
          {postStore.map((post: IPost) => (
            <CampaignPost key={post.id} post={post} />
          ))}
        </div>
      )}
      {!postStore.length && !searching && (
        <div className="flex justify-center items-center h-96">
          No posts found
        </div>
      )}
      <Outlet />
    </div>
  );
};

export default CampaignPostSearchPartial;
